import React from 'react'
import FormGroup from '../FormGroup/FormGroup'
import FormTextArea from '../FormTextArea/FormTextArea'

function FormGroupTextArea({
    className,
    errors,
    id,
    label,
    name,
    required,
    ...rest
}) {
    return (
        <FormGroup
            className={className}
            errors={errors}
            id={id}
            label={label}
            required={required}
        >
            <FormTextArea id={id} name={name} errors={errors} {...rest} />
        </FormGroup>
    )
}

export default FormGroupTextArea
